import { Notification } from 'rsuite';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import styles from '../../../../components/NotificationMessage/NotificationMessage.module.scss';

const STYLE_CLASS = {
  success: 'notification-success',
  error: 'notification-error',
};

let notificationCounter = 0;

export const notify = (type: 'success' | 'error', duration: number, message: string) => {
  notificationCounter += 1;

  const icon =
    type === 'success' ? <CheckCircleIcon className={styles['success-icon']} /> : <ErrorIcon className={styles['error-icon']} />;

  Notification.open({
    key: `central-de-monitoramento-notification-${notificationCounter}`,
    className: styles[STYLE_CLASS[type]],
    duration,
    description: (
      <>
        {icon}
        <p>{message}</p>
      </>
    ),
  });
};
